let _history = null;

function setHistory(history) {
  _history = history;
}

function push(route) {
  _history.push(route);
}

// SPA-navigate from an anchor click: keep the browser's new-tab/modifier
// behavior, otherwise push through react-router (no full page reload). Falls
// back to a normal navigation if the router history isn't available yet.
function navigate(e, route) {
  if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)) return;
  if (e) e.preventDefault();
  if (_history) {
    _history.push(route);
    return;
  }
  window.location.assign(route);
}

export default {
  setHistory,
  push,
  navigate,
};
